import { Link } from "react-router-dom";
import "./review-card-style.scss";

//顧客評價卡
//
//  版型跟各產品故事頁的回饋區塊一致（baiye-story / jingyue-story /
//  feihong-story 的 reviews）：遮罩信箱 → 星星 → 評語。
//
//  ⚠️ 原本是「五行色塊頭像 + 日干」。拿掉的理由不只是視覺不統一 ——
//  日干要有生辰才算得出來，而伏爻子只收問題與起卦方式（見 products.js
//  的 inputs）。那排頭像等於替一部分使用者編造我們從沒收集的資料。
//  信箱是每一筆評價都一定有的東西，拿它當身分才不會有例外。
//
//  信箱在後端就遮好了（只留前兩碼），前端不做二次處理 ——
//  遮罩邏輯放後端才可靠。
const ReviewCard = ({ review }) => {
  const { email, rating, repeatCount, timeAgo, content, product } = review;

  return (
    <article className="rvc">
      <div className="rvc__head">
        <p className="rvc__email">{email}</p>
        <span className="rvc__time">{timeAgo}</span>
      </div>

      <div className="rvc__meta">
        {/* 星星用「★」字元重複、不用圖示 —— 跟故事頁同一套寫法：
            它要跟著文字一起縮放、一起繼承顏色，用圖的話兩邊會各調一次。 */}
        <p className="rvc__stars" aria-label={`五顆星中的 ${rating} 顆`}>
          <span aria-hidden="true">{"★".repeat(rating)}</span>
          <span className="rvc__stars-off" aria-hidden="true">
            {"★".repeat(5 - rating)}
          </span>
        </p>

        {/* 回購次數是最有說服力的訊號，所以獨立做成標記而不是混在文字裡 */}
        {repeatCount > 1 && (
          <span className="rvc__repeat">第 {repeatCount} 次購買</span>
        )}
      </div>

      <p className="rvc__content">{content}</p>

      {product && (
        <Link to={product.path || "#"} className="rvc__product">
          <span
            className={`rvc__product-cover rvc__product-cover--${product.theme}`}
          >
            {product.glyph}
          </span>

          <span className="rvc__product-text">
            <strong>{product.title}</strong>
            <small>{product.subtitle}</small>
          </span>

          <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
            <path
              d="M9 5l7 7-7 7"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      )}
    </article>
  );
};

export default ReviewCard;
